import { render, staticRenderFns } from "./page_login.vue?vue&type=template&id=47b50204&"
import script from "./page_login.vue?vue&type=script&lang=js&"
export * from "./page_login.vue?vue&type=script&lang=js&"
import style0 from "./page_login.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports